import React from 'react';

const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

/** Cabeçalho compacto Dom–Sab: chip branco centrado por coluna (alinha à grelha abaixo). */
const CalendarWeekHeader = () => {
  return (
    <div
      role="row"
      className="grid shrink-0 grid-cols-7 border-b border-gray-200 bg-transparent py-1"
    >
      {WEEK_DAYS.map((day) => (
        <div
          key={day}
          role="columnheader"
          className="flex min-h-[24px] min-w-0 items-center justify-center border-r border-gray-200 px-0.5"
        >
          <span className="inline-flex max-w-full items-center justify-center rounded-md bg-white px-2 py-0.5 text-[11px] font-medium leading-none tracking-tight text-gray-700 shadow-sm ring-1 ring-gray-200/90">
            {day}
          </span>
        </div>
      ))}
    </div>
  );
};

export default CalendarWeekHeader;
